import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class PhoneNumberComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentPhoneNumber | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.defaultValue = settings?.defaultValue ?? '';
		this.disabled = settings?.disabled ?? false;
		this.input = true;
		this.inputType = settings?.inputType ?? 'tel';
		this.kdata = {
			defaults: {
				country: 'FR',
			},
			submit: true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? true;
		this.placeholder = settings?.placeholder ?? '';
		this.prefix = settings?.prefix ?? '';
		this.protected = settings?.protected ?? false;
		this.suffix = settings?.suffix ?? '';
		this.validate = {
			card: new Card(settings?.validate?.card ?? '0-1'),
			custom: settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'data',
			'number',
		]);
	}
}
